export const COMISSAO_HUB = 4;

export const origemLeadOptions = [
  { value: "2", label: "Prospecção" },
  { value: "3", label: "WhatsApp" },
  { value: "4", label: "Indicação - Agente" },
  { value: "6", label: "Anúncios" },
  { value: "13", label: "Ligação Recebida" },
  { value: "19", label: "Indicação do Cliente" },
  { value: "20", label: "Lead" },
  { value: "21", label: "WhatsApp Due" },
  { value: "22", label: "Carteira" },
];

export const tipoPropostaOptions = [
  { value: "1", label: "Apartada" },
  { value: "2", label: "Faturada" },
  { value: "3", label: "Mista" },
];

export const axisOptions = [
  { value: "1", label: "Sim" },
  { value: "0", label: "Não" },
];

export const estadoCivilOptions = [
  { value: "s", label: "Solteiro(a)" },
  { value: "c", label: "Casado(a)" },
  { value: "d", label: "Divorciado(a)" },
  { value: "v", label: "Viúvo(a)" },
  { value: "u", label: "União Estável" },
];

export const HUB_STATUS_COLUMNS = [
  { statusCode: -1, descricao: "Pendentes", color: "#a1a1a1" },
  { statusCode: 0, descricao: "Enviadas", color: "#635b8f" },
  { statusCode: 1, descricao: "Vistas", color: "#5d99cc" },
  { statusCode: 2, descricao: "Aprovadas", color: "#68cc5d" },
  { statusCode: 3, descricao: "Rejeitadas", color: "#ca5757" },
] as const;

export function getDescricaoOrigemLead(idOrigemLead: string) {
  if (!idOrigemLead) return "";
  return (
    origemLeadOptions.find((item) => item.value === idOrigemLead)?.label || ""
  );
}

export function getDescricaoTipoProposta(tipo?: string | number) {
  const value = String(tipo ?? "");
  return (
    tipoPropostaOptions.find((item) => item.value === value)?.label ||
    "Não informada"
  );
}

/** Normaliza axis da API/form para 1 | 0 | null (mesmo contrato do backend). */
export function parseAxis(raw: unknown): 0 | 1 | null {
  if (raw === null || raw === undefined || raw === "") {
    return null;
  }
  if (raw === true || raw === 1 || raw === "1") {
    return 1;
  }
  if (raw === false || raw === 0 || raw === "0") {
    return 0;
  }
  return null;
}

export function getAxisFormValue(axis?: 0 | 1 | null): string {
  return axis === 0 || axis === 1 ? `${axis}` : "";
}

export function getHubStatusTag(status?: number) {
  const col = HUB_STATUS_COLUMNS.find((c) => c.statusCode === status);
  if (!col) {
    return { label: "Nova Proposta", color: "#6B7280" };
  }
  return { label: col.descricao, color: col.color };
}

export function createEmptyProposta(
  idCorretor: number,
  idEmpresa: number,
): import("../types/proposta").IProposta {
  return {
    id_proposta: null,
    id_corretor: idCorretor,
    corretores: [],
    is_ppm: null,
    status: undefined,
    status_kanban: undefined,
    id_empresa: idEmpresa,
    comissao: COMISSAO_HUB,
    id_origem_lead: "",
    descricao_origem_lead: "",
    tipo_proposta: "",
    axis: null,
    observacao: "",
    published: false,
    imovel: {
      id_imovel: "",
      descricao_imovel: "",
      bloco: "",
      imovel_seminovo: 0,
      unidade: "",
      id_construtora: "",
      descricao_construtora: "",
      valor: "",
    },
    proponentes: [],
    pagamentos: [],
    uuid: undefined,
  };
}
